import type { Chart, TooltipModel } from 'chart.js';

import styles from '../active-plays-chart.module.css';

/**
 * Renders a custom HTML tooltip for Chart.js, positioned above the hovered data point.
 *
 * Each line is split at the first colon — the part before (including the colon) is rendered
 * with a lighter font weight, and the part after with a heavier weight.
 * Lines without a colon are rendered entirely in the light style.
 */
export function externalTooltip({ chart, tooltip }: { chart: Chart; tooltip: TooltipModel<'line'> }, lines: string[]) {
  let tooltipElement = chart.canvas.parentElement?.querySelector(`.${styles.tooltip}`) as HTMLDivElement | null;

  if (!tooltipElement) {
    tooltipElement = document.createElement('div');
    tooltipElement.className = styles.tooltip;
    chart.canvas.parentElement?.appendChild(tooltipElement);
  }

  if (tooltip.opacity === 0) {
    tooltipElement.style.opacity = '0';
    return;
  }

  tooltipElement.textContent = '';

  for (const line of lines) {
    const row = document.createElement('div');
    const colonIndex = line.indexOf(':');

    if (colonIndex === -1) {
      const span = document.createElement('span');
      span.className = styles.tooltipLabel;
      span.textContent = line;
      row.appendChild(span);
    } else {
      const labelSpan = document.createElement('span');
      labelSpan.className = styles.tooltipLabel;
      labelSpan.textContent = line.slice(0, colonIndex + 1);

      const valueSpan = document.createElement('span');
      valueSpan.className = styles.tooltipValue;
      valueSpan.textContent = line.slice(colonIndex + 1);

      row.appendChild(labelSpan);
      row.appendChild(valueSpan);
    }

    tooltipElement.appendChild(row);
  }

  tooltipElement.style.opacity = '1';
  tooltipElement.style.left = `${tooltip.caretX}px`;
  tooltipElement.style.top = `${tooltip.caretY - 8}px`;
  tooltipElement.style.transform = 'translate(-50%, -100%)';
}
